import {
  geolocationOutOfBounds,
  manualLocationReverseGeocoded,
  manualLocationRemoved,
  positionReverseGeocoded,
  setSelectedLocationSuccess,
} from '#/shared/slices/location';
import { storeItem } from '#/shared/utils/storage';
import {
  MANUAL_LOCATION_STORAGE_KEY,
  GEOLOCATION_APPROVED_STORAGE_KEY,
} from '#/shared/constants';
import { isOutsideBounds, positionToLocation } from '#/shared/utils/location';
import { fetchLocationLabel } from '#/shared/utils/reverse-geocoder';

const boundsSelector = s => s.shared.location.locationConfig.bounds;

export const manualLocationChosen =
  ({ lat, lng }) =>
  async (dispatch, getState) => {
    const { label, region } = await fetchLocationLabel(getState, {
      lat,
      lon: lng,
    });
    const labeledLocation = {
      lat,
      lon: lng,
      name: label,
      state: region,
    };
    dispatch(manualLocationReverseGeocoded(labeledLocation));
    storeItem(MANUAL_LOCATION_STORAGE_KEY, labeledLocation);
  };

export const manualLocationClear = () => dispatch => {
  dispatch(manualLocationRemoved());
  storeItem(MANUAL_LOCATION_STORAGE_KEY, null);
};

export const positionSuccess =
  (position, successCallback) => async (dispatch, getState) => {
    const location = positionToLocation(position);

    if (isOutsideBounds(location, boundsSelector(getState()))) {
      dispatch(geolocationOutOfBounds());
      storeItem(GEOLOCATION_APPROVED_STORAGE_KEY, false);
      return;
    }

    const { coords } = position;
    const { latitude, longitude } = coords;
    const { label } = await fetchLocationLabel(getState, location);

    dispatch(
      positionReverseGeocoded({
        // only serializable values can be sent into reducers so this
        // GeolocationCoordinate object must be converted to as simple
        // JavaScript object
        coords: { latitude, longitude },
        name: label,
      })
    );

    if (successCallback) successCallback([position, label]);
  };

export const getAndSetLocationLabel =
  (lat, lon) => async (dispatch, getState) => {
    const { label } = await fetchLocationLabel(getState, { lat, lon });
    const addressName = label || `(${lat.toFixed(3)}, ${lon.toFixed(3)})`;
    const selectedLocation = {
      name: addressName,
      address: addressName,
      lat,
      lon,
    };
    dispatch(setSelectedLocationSuccess(selectedLocation));
    return selectedLocation;
  };
